import { render } from "./learning-map.vue?vue&type=template&id=24b9aa36&ts=true"
import script from "./learning-map.vue?vue&type=script&lang=ts"
export * from "./learning-map.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__